/**
 * MarkdownContent Component
 * Styled markdown component that matches Typography body2 styling
 */

import React from "react";
import { Box } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownContent = ({ children }) => (
        <Box
                sx={{
                        "& > :first-of-type": { mt: 0 },
                        "& > *:last-child": { mb: 0 },
                        "& p": {
                                margin: 0,
                                marginBottom: "0.5em",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                        },
                        "& strong": {
                                fontWeight: 600,
                        },
                        "& em": {
                                fontStyle: "italic",
                        },
                        "& ul, & ol": {
                                margin: "0.5em 0",
                                paddingLeft: "1.5em",
                        },
                        "& li": {
                                margin: "0.25em 0",
                        },
                        "& h1, & h2, & h3, & h4, & h5, & h6": {
                                margin: "0.5em 0",
                                fontWeight: 600,
                        },
                        "& h1": { fontSize: "1.5em" },
                        "& h2": { fontSize: "1.3em" },
                        "& h3": { fontSize: "1.1em" },
                        "& code": {
                                backgroundColor: "rgba(0, 0, 0, 0.06)",
                                padding: "0.125em 0.25em",
                                borderRadius: "3px",
                                fontSize: "0.9em",
                                fontFamily: "monospace",
                        },
                        "& pre": {
                                backgroundColor: "rgba(0, 0, 0, 0.06)",
                                padding: "0.5em",
                                borderRadius: "4px",
                                overflow: "auto",
                                margin: "0.5em 0",
                        },
                        "& pre code": {
                                backgroundColor: "transparent",
                                padding: 0,
                        },
                }}
        >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
        </Box>
);

export default MarkdownContent;

